import { createAction, props } from '@ngrx/store';

export const getCategories = createAction('[Categories] Get Categories', props<any>());
export const categoriesFailure = createAction('[Categories] Categories failed', props<any>());
export const categoriesSuccess = createAction('[Categories] Categories sucess', props<any>());

export const getCategoryDetails = createAction('[Categories details] Get Categories details', props<any>());
export const categoryDetailsFailure = createAction('[Categories details] Categories details failed', props<any>());
export const categoryDetailsSuccess = createAction('[Categories details] Categories details sucess', props<any>());
